// Build-time mirror of the API's REGISTRATION_ENABLED kill switch.
//
// The API is the enforcement authority — it 403s with `REGISTRATION_DISABLED`
// on every path that would create an account for a stranger. This flag only
// hides the sign-up UI so nobody is walked into a dead end. Both are fed from
// the same GitHub `Prod` variable (see .github/workflows/build_test_deploy.yml),
// so the button and the endpoint can't disagree.
//
// Fails OPEN: only the exact string "false" closes sign-ups, so a typo or an
// unset var leaves the product working normally.
import { envSwitch } from './killSwitch';

export const registrationEnabled = envSwitch('VITE_REGISTRATION_ENABLED');
